import React from 'react';
import { Ban, Forward, Pin, Star } from 'lucide-react';

const KIND_LABEL = { image: 'Photo', video: 'Video', audio: 'Audio', document: 'File' };

// The quoted message shown above a reply.
export const ReplyQuote = ({ reply, author }) => {
    if (!reply) return null;
    const body = reply.kind === 'deleted' ? 'This message was deleted' : reply.text || KIND_LABEL[reply.kind] || 'Message';
    return (
        <div className="msg-quote">
            <b>{author}</b>
            <span>{body}</span>
        </div>
    );
};

export const ForwardedTag = ({ item }) => (item?.forwarded ? <div className="msg-forwarded"><Forward size={12} /> Forwarded</div> : null);

// What a deleted-for-everyone message turns into.
export const DeletedText = () => <p className="msg-deleted"><Ban size={13} /> This message was deleted</p>;

// Emoji reactions under a bubble. Clicking a chip adds / removes your own reaction.
export const Reactions = ({ reactions, onToggle, end = false }) => {
    if (!reactions?.length) return null;
    return (
        <div className={`msg-reactions${end ? ' is-end' : ''}`}>
            {reactions.map(r => (
                <button key={r.emoji} type="button" className={r.mine ? 'is-mine' : ''} onClick={() => onToggle?.(r.emoji)} title={r.mine ? 'Remove your reaction' : 'React with this'}>
                    <span>{r.emoji}</span>{r.count > 1 && <small>{r.count}</small>}
                </button>
            ))}
        </div>
    );
};

// Small pin / star / "edited" markers that sit next to the time.
export const MessageFlags = ({ item }) => (
    <>
        {item.pinned && <Pin size={12} className="msg-flag" fill="currentColor" aria-label="Pinned" />}
        {item.starred && <Star size={12} className="msg-flag" fill="currentColor" aria-label="Starred" />}
        {item.edited && <span className="msg-flag-text">edited</span>}
    </>
);

// Strip above the chat showing the newest pinned message; click it to see all pinned messages.
export const PinnedBanner = ({ items, onOpen }) => {
    const pinned = (items || []).filter(i => i.pinned && !i.deleted);
    if (!pinned.length) return null;
    const latest = pinned[pinned.length - 1];
    return (
        <button type="button" className="msg-pinned-banner" onClick={onOpen}>
            <Pin size={14} />
            <span><b>Pinned message{pinned.length > 1 ? `s (${pinned.length})` : ''}</b>{latest.text || KIND_LABEL[latest.attachment?.kind] || 'Attachment'}</span>
        </button>
    );
};
